import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { AdminPanelDrawerProvider } from '@views/pages/Admin/context';

export const AdminPanel = () => {
  return (
    <Box>
      <AdminPanelDrawerProvider>
        <Outlet />
      </AdminPanelDrawerProvider>
    </Box>
  );
};
